<template>
  <SysDialog
    v-model="dialog_ativo"
    titulo="Adicionar Estoque Mínimo"
    :largura="'1000px'"
  >
    <template #ativador>
      <v-btn class="ml-5" color="primary" small @click="dialog_ativo = true">
        <v-icon left>mdi-pencil</v-icon>
        Adicionar Estoque Mínimo
      </v-btn>
    </template>

    <div v-if="dialog_ativo">
      <v-row>
        <v-col class="pb-0">
          <SysFilialGrupoAutocomplete
            v-model="registro.filiais"
            label="Selecione as filiais"
            outlined
            multiple
          />
        </v-col>

        <v-col class="pb-0">
          <TextFieldFormatadorDeValor
            v-model="registro.estoque_min"
            label="Informe o valor de estoque mínimo"
            outlined
            :max-digitos="4"
            remover-valor-irrelevante
            centralizar
            @focus="$event.target.select()"
            @keydown.enter="validarValor"
          />
        </v-col>
      </v-row>

      <SysSelecaoProdutosPorTabela :model-value="registro.produtos" @update:modelValue="registro.produtos = $event"/>
    </div>

    <template #actions>
      <v-btn :disabled="Number(registro.estoque_min) === 0" text color="primary" @click="validarValor">
        Salvar
      </v-btn>
    </template>
  </SysDialog>
</template>

<script setup>
import {salvar} from "@/components/drp/AnaliseParametrosProdutoDrp/EstoqueMinimo/utils";
import {ref, watch} from "vue";
import Api from "@/api/api";
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import TextFieldFormatadorDeValor from "@/components/utils/TextFieldFormatadorDeValor.vue";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete.vue";
import SysSelecaoProdutosPorTabela from "@/components/utils/crud/SysSelecaoProdutosPorTabela.vue";

const props = defineProps({
  produtos_selecionados: Array,
});

const emit = defineEmits(['cadastro:estoque-min']);

const dialog_ativo = ref(false);

const registro = ref({
  filiais: [],
  produtos: [],
  estoque_min: '',
});

watch(dialog_ativo, () => {
  if (!dialog_ativo.value) {
    registro.value.produtos = [];
    registro.value.estoque_min = '';
    return;
  }

  const params = {
    iddepartamento: [...new Set(props.produtos_selecionados.map(m => m.iddepartamento).filter(f => f))],
    idsecao: [...new Set(props.produtos_selecionados.map(m => m.idsecao).filter(f => f))],
    idfornecedor: [...new Set(props.produtos_selecionados.map(m => m.idfornecedor).filter(f => f))],
    idproduto: [...new Set(props.produtos_selecionados.map(m => m.idproduto).filter(f => f))],
    filial: [...new Set(props.produtos_selecionados.map(m => m.filial).filter(f => f))],
  }

  Api.get('drp/analise-parametros-produto/array-produtos-filiais', { params })
    .then(response => {
      const { filiais, produtos } = response.data;
      
      registro.value.filiais = [...new Set(Object.values(filiais))];
      registro.value.produtos = [...new Set(Object.values(produtos))];
    });
});

function validarValor() {
  if (!Number(registro.value.estoque_min) > 0) return;

  const parametros = {
    ...registro.value,
    produtos: registro.value.produtos.map(m => m.idproduto)  
  }

  salvar(parametros)
    .finally(() => {
      dialog_ativo.value = false;
      emit('cadastro:estoque-min', {});
    });
}
</script>
